import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { UserPreferencesService } from '@core/services/user-preferences.service';
import { DadataAddressComponent } from '@shared/components/dadata-address/dadata-address.component';
import { IAddressModel } from '@shared/models/addresses/addresses.model';
import { CustomButtonComponent } from '@shared/ui/custom-button/custom-button.component';

@Component({
  selector: 'app-city-selection-dialog',
  templateUrl: './city-selection-dialog.component.html',
  styleUrls: ['./city-selection-dialog.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatAutocompleteModule,
    DadataAddressComponent,
    CustomButtonComponent
  ]
})
export class CitySelectionDialogComponent {
  private dialogRef = inject(MatDialogRef<CitySelectionDialogComponent>);
  private userPrefs = inject(UserPreferencesService);
  
  cityControl = new FormControl<IAddressModel | null>(null);
  
  /**
   * Save the selected city and close the dialog
   */
  onSubmit(): void {
    const cityValue = this.cityControl.value;
    if (cityValue && cityValue.city) {
      this.userPrefs.setCity(cityValue.city);
      this.dialogRef.close(cityValue.city);
    }
  }

  close(): void {
    this.dialogRef.close();
  }
} 